import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import SettlementAccountDto from "../../dto/Dictionaries/SettlementAccountDto";
import { CashAccountConfigDto } from "../../dto/Deal/CashAccountConfigDto";
import { CashAccountForm, CashContext, CashRateRequest } from "./model";
const initialState: {
  context?: CashContext;
  config?: CashAccountConfigDto;
  bank?: SettlementAccountDto;
  loading: boolean;
  saving: boolean;
  error?: string;
  revision: number;
  rateRequestId?: string;
  rateLoading: boolean;
  rate?: string;
  rateError?: string;
} = { loading: false, saving: false, revision: 0, rateLoading: false };
const same = (a: CashContext | undefined, b: CashContext) =>
  a?.dealId === b.dealId && a.companyId === b.companyId && Boolean(a.readOnly) === Boolean(b.readOnly);
const slice = createSlice({
  name: "cashReimbursements",
  initialState,
  reducers: {
    load(state, { payload }: PayloadAction<CashContext>) {
      if (!same(state.context, payload)) return { ...initialState, context: payload, loading: true };
      state.context = payload;
      state.loading = true;
      state.error = undefined;
      state.config = undefined;
      state.bank = undefined;
    },
    loadSuccess(state, { payload }: PayloadAction<{ context: CashContext; config: CashAccountConfigDto; bank?: SettlementAccountDto }>) {
      if (!same(state.context, payload.context)) return;
      state.config = payload.config;
      state.bank = payload.bank;
      state.loading = false;
    },
    loadReject(state, { payload }: PayloadAction<{ context: CashContext; error: string }>) {
      if (!same(state.context, payload.context)) return;
      state.loading = false;
      state.error = payload.error;
      state.config = undefined;
      state.bank = undefined;
    },
    clearRate(state) {
      state.rateRequestId = undefined;
      state.rateLoading = false;
      state.rate = undefined;
      state.rateError = undefined;
    },
    loadRate(state, { payload }: PayloadAction<CashRateRequest>) {
      if (!same(state.context, payload.context)) return;
      state.rateRequestId = payload.requestId;
      state.rateLoading = true;
      state.rate = undefined;
      state.rateError = undefined;
    },
    loadRateSuccess(state, { payload }: PayloadAction<{ context: CashContext; requestId: string; rate: string }>) {
      if (!same(state.context, payload.context) || state.rateRequestId !== payload.requestId) return;
      state.rateLoading = false;
      state.rate = payload.rate;
    },
    loadRateReject(state, { payload }: PayloadAction<{ context: CashContext; requestId: string; error: string }>) {
      if (!same(state.context, payload.context) || state.rateRequestId !== payload.requestId) return;
      state.rateLoading = false;
      state.rateError = payload.error;
    },
    save(state, _action: PayloadAction<{ context: CashContext; id?: number; form: CashAccountForm; autoRate?: boolean }>) {
      state.saving = true;
      state.error = undefined;
    },
    saveSuccess(state, { payload }: PayloadAction<CashContext>) {
      if (same(state.context, payload)) {
        state.saving = false;
        state.revision++;
      }
    },
    saveReject(state, { payload }: PayloadAction<{ context: CashContext; error: string }>) {
      if (same(state.context, payload.context)) {
        state.saving = false;
        state.error = payload.error;
      }
    },
    remove(state, _action: PayloadAction<{ context: CashContext; id: number; revision: number }>) {
      state.saving = true;
      state.error = undefined;
    },
    removeSuccess(state, { payload }: PayloadAction<CashContext>) {
      if (same(state.context, payload)) state.saving = false;
    },
    removeReject(state, { payload }: PayloadAction<{ context: CashContext; error: string }>) {
      if (same(state.context, payload.context)) {
        state.saving = false;
        state.error = payload.error;
      }
    },
  },
});
export default slice;
